import { StyleSheet, View } from 'react-native';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';

import AmenitiesItem from './AmenitiesItem';
import AuditItem from './AuditItem';
import BalanceSheetItem from './BalanceSheetItem';
import BoardItem from './BoardItem';
import ByLawsItem from './ByLawsItem';
import ChecksItem from './ChecksItem';
import FundraisingItem from './FundraisingItem';
import ImpactStudyItem from './ImpactStudyItem';
import LandEquipmentsItem from './LandEquipmentsItem';
import MapItem from './MapItem';
import NineNinetyItem from './NineNinetyItem';
import PastorItem from './PastorItem';
import PLItem from './PLItem';
import ProgramsItem from './ProgramsItem';
import QuestionItem from './QuestionItem';
import RevenueItem from './RevenueItem';
import SalariesItem from './SalariesItem';
import SummaryItem from './SummaryItem';
import TotalSalariesItem from './TotalSalariesItem';

const InsightsComponent = ({ canEdit, data }: { canEdit: boolean; data: NonProfitOrgProfileResponse | undefined }) => {
  if (!data) return null;
  const type = data.type;
  return (
    <View style={styles.container}>
      <SummaryItem canEdit={canEdit} nonProfitOrg={data} />
      <RevenueItem canEdit={canEdit} nonProfitOrg={data} />
      <TotalSalariesItem canEdit={canEdit} nonProfitOrg={data} />
      <FundraisingItem canEdit={canEdit} nonProfitOrg={data} />
      <LandEquipmentsItem canEdit={canEdit} nonProfitOrg={data} />
      {/* ToDO: Waiting definition if show or not */}
      {/* <AllocationItem data={data.expensesAllocation} /> */}
      <SalariesItem canEdit={canEdit} data={data.salaries} npoId={data.id} type={type} />
      {type === 'CHURCH' && <PastorItem canEdit={canEdit} data={data.pastors} npoId={data.id} />}
      <BoardItem canEdit={canEdit} data={data.usersBoardDirectory} npoId={data.id} />
      <ChecksItem canEdit={canEdit} nonProfitOrg={data} />
      {type === 'CHURCH' && <ByLawsItem canEdit={canEdit} byLawsDoc={data.byLawsDoc} programs={data.programs} />}
      <PLItem canEdit={canEdit} pl={data.plStatement} balanceSheet={data.balanceSheet} npoId={data.id} />
      <BalanceSheetItem canEdit={canEdit} pl={data.plStatement} balanceSheet={data.balanceSheet} npoId={data.id} />
      {type === 'CHARITIES' && <NineNinetyItem nineNintyForm={data.nineNintyForm} />}
      <AuditItem
        canEdit={canEdit}
        thirdPartyAudit={data.thirdPartyAudit}
        thirdPartyAuditDeny={data.thirdPartyAuditDeny}
        npoId={data.id}
      />
      <ImpactStudyItem canEdit={canEdit} impactStudy={data.impactStudy} impactStudyDeny={data.impactStudyDeny} />
      <ProgramsItem
        canEdit={canEdit}
        data={data.programs}
        type={data.type}
        totalGrant={data.totalGrantsPrograms}
        byLaws={data.byLawsDoc}
      />
      {type === 'CHURCH' && <AmenitiesItem canEdit={canEdit} data={data.amenities} npoId={data.id} />}
      <QuestionItem canEdit={canEdit} npoId={data.id} name={data.name} />

      {(type === 'CHURCH' || data.showMap) && data.location && (
        <MapItem
          markerCoordinates={data.location.coordinates}
          markerTitle={data.name}
          markerDescription={data.description}
        />
      )}
    </View>
  );
};

export default InsightsComponent;

const styles = StyleSheet.create({
  container: {
    gap: 20
  }
});
